// extracted by mini-css-extract-plugin
export default {"todo":"Todo_todo__CE4ct","checkbox":"Todo_checkbox__GVglj","text":"Todo_text__T4iRg","icon":"Todo_icon__J1eSi","button":"Todo_button__yKt9p"};